import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive } from "vue";
import { useStore } from "vuex";
import { useState } from "@/hooks/mapGet/index.js";
import MvList from "@/components/mv-list/mvList.vue";
import Loading from "@/baseui/loading/loading.vue";
export default defineComponent({
  name: "Alone",
  setup: function setup() {
    var store = useStore();
    var state = useState("Home", ["aloneList"]);
    /* 请求数据 */

    var aloneResInfo = reactive({
      limit: 100,
      offset: 0
    });
    store.dispatch("Home/getAloneList", aloneResInfo);
    return _objectSpread({}, state);
  },
  components: {
    MvList: MvList,
    Loading: Loading
  }
});